export const UnitsUtil = {
    parseSatoshis(amount, network) {
        const value = parseFloat(amount) / 10 ** network.nativeCurrency.decimals;
        // eslint-disable-next-line new-cap
        return Intl.NumberFormat('en-US', {
            maximumFractionDigits: network.nativeCurrency.decimals
        }).format(value);
    }
};
//# sourceMappingURL=UnitsUtil.js.map